import { clsx } from "clsx";

/** Medidor: una razón contra un límite (track del mismo ramp, relleno marino). La marca es un tick vertical con etiqueta. */
export function Medidor({ valor, max = 1, marca, etiquetaMarca, alto = 8, etiqueta, color = "var(--viz-serie)" }: {
  valor: number | null; max?: number; marca?: number; etiquetaMarca?: string; alto?: number; etiqueta: string; color?: string;
}) {
  const pct = valor === null ? 0 : Math.max(0, Math.min(1, valor / max));
  const marcaPct = marca === undefined ? null : Math.max(0, Math.min(1, marca / max));
  return (
    <div className="w-full">
      <div className="relative w-full rounded-full" style={{ height: alto, background: "var(--viz-track)" }} role="meter" aria-label={etiqueta}
        aria-valuemin={0} aria-valuemax={max} aria-valuenow={valor ?? undefined}>
        <div className={clsx("h-full rounded-full transition-[width] duration-300 motion-reduce:transition-none")} style={{ width: `${pct * 100}%`, background: color }} />
        {marcaPct !== null && <div className="absolute top-[-3px] w-0.5 rounded" style={{ left: `calc(${marcaPct * 100}% - 1px)`, height: alto + 6, background: "var(--viz-objetivo)" }} aria-hidden />}
      </div>
      {marcaPct !== null && etiquetaMarca && (
        <div className="relative mt-1 h-4 text-[11px] text-tinta-suave">
          <span className="absolute -translate-x-1/2 whitespace-nowrap" style={{ left: `${Math.min(92, Math.max(8, marcaPct * 100))}%` }}>{etiquetaMarca}</span>
        </div>
      )}
    </div>
  );
}
